import { render, staticRenderFns } from "./IconsList.vue?vue&type=template&id=ca5efd78&scoped=true&"
import script from "./IconsList.vue?vue&type=script&lang=ts&"
export * from "./IconsList.vue?vue&type=script&lang=ts&"
import style0 from "./IconsList.vue?vue&type=style&index=0&id=ca5efd78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca5efd78",
  null
  
)

export default component.exports